import { render, staticRenderFns } from "./DashboardStatsGrid.vue?vue&type=template&id=21f85dbd&scoped=true"
import script from "./DashboardStatsGrid.vue?vue&type=script&lang=js"
export * from "./DashboardStatsGrid.vue?vue&type=script&lang=js"
import style0 from "./DashboardStatsGrid.vue?vue&type=style&index=0&id=21f85dbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f85dbd",
  null
  
)

export default component.exports